import { Component, OnInit } from '@angular/core';

export class ScriptGenerator {

	public scriptText = '';
	public platformIp = '1.1.1.1';

	// public doGeneratePortAssignment = true;

	private _doGeneratePortAssignment: string;
	public get doGeneratePortAssignment(): string {
		return this._doGeneratePortAssignment;
	}
	public set doGeneratePortAssignment(v: string) {
		this._doGeneratePortAssignment = v;
		this.generate();
	}

	public chassisIp = '1.1.1.1';
	public leftCard = 1;
	public leftPort = 1;
	public rightCard = 2;
	public rightPort = 1;

	private _scriptHeaderSection = '';
	private _scriptBody = '';


	public generate() {
		this.generateBaseLine();
		if (this.doGeneratePortAssignment) {
			this.generatePortAssignment();
		}

		this.scriptText = this._scriptHeaderSection + this._scriptBody;
	}

	private generateBaseLine() {
		this._scriptHeaderSection = `"""A simple script that demonstrates how to get started with ixnetwork_restpy scripting.

"""

from ixnetwork_restpy.testplatform.testplatform import TestPlatform
`;

		this._scriptBody = `

# connect to a windows test platform using the default api server rest port
test_platform = TestPlatform('${this.platformIp}')

# use the default session and get the root node of the hierarhcy
ixnetwork = test_platform.Sessions.find().Ixnetwork

# clear any configuration that may be present
ixnetwork.NewConfig()

# add a virtual port
vport = ixnetwork.Vport.add(Name='Abstract Test Port 1')

# add 10 ipv4 devices
ipv4_devices = ixnetwork.Topology.add(Ports=vport).DeviceGroup.add(Multiplier=10).Ethernet.add().Ipv4.add()
`;
	}

	private generatePortAssignment() {
		this._scriptHeaderSection += `from ixnetwork_restpy.assistants.ports.portmapassistant import PortMapAssistant`;

		this._scriptBody += `
# create a port map assistant instance
port_map = PortMapAssistant(session.Ixnetwork)

# add mappings between test port locations and vport names
# if the vport name does not exist or is not supplied a vport will be created
# the vport will be returned as part of the call
# TAM FIXME: Use second card/port
vport = port_map.Map(IpAddress='${this.chassisIp};', CardId=${this.leftCard}, PortId=${this.leftPort}, Name='Port %s' % x)
print(port_map)

port_map.Connect(ForceOwnership=True)
print(port_map)`;
	}
}

@Component({
	selector: 'script-generator',
	templateUrl: './script-generator.component.html',
	styleUrls: ['./script-generator.component.scss']
})
export class ScriptGeneratorComponent implements OnInit {

	// tslint:disable-next-line: max-line-length
	public get scriptContent() {
		return this.scriptGenerator.scriptText;
	}

	public readonly scriptGenerator = new ScriptGenerator();

	constructor() { }

	ngOnInit() {
		this.generateScript();
	}

	public onPlatformIpChange(value: string) {
		this.scriptGenerator.platformIp = value;
		this.generateScript();
	}
	public onChassisIpChange(value: string) {
		this.scriptGenerator.chassisIp = value;
		this.generateScript();
	}
	public onLeftCardChange(value: string) {
		this.scriptGenerator.leftCard = parseInt(value, 10);
		this.generateScript();
	}
	public onLeftPortChange(value: string) {
		this.scriptGenerator.leftPort = parseInt(value, 10);
		this.generateScript();
	}
	public onRightCardChange(value: string) {
		this.scriptGenerator.rightCard = parseInt(value, 10);
		this.generateScript();
	}
	public onRightPortChange(value: string) {
		this.scriptGenerator.rightPort = parseInt(value, 10);
		this.generateScript();
	}


	private generateScript() {
		this.scriptGenerator.generate();
	}


}
